import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudOff2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCloudOff2"><Path d="M16.4898 6.29981C17.6215 7.38119 18.3633 8.86721 18.483 10.5256C20.7411 10.7666 22.5 12.6779 22.5 15C22.5 17.4853 20.4853 19.5 18 19.5H9.5M16 3L6 21.5M14.5 4.99816C13.7304 4.67723 12.8859 4.5 12 4.5C9.25838 4.5 6.91321 6.19737 5.95801 8.59857C3.4187 9.08552 1.5 11.3187 1.5 14C1.5 16.9984 3.89937 19.4364 6.88284 19.4988" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCloudOff2;
